import { sections } from "../../common/config";

export function getTranslateY(dom: HTMLElement) {
  const attr = dom.style.transform;

  let translateY = attr.split(",")[1].trim();

  if (translateY[translateY.length - 1] === ")")
    translateY = translateY.slice(0, -1);

  translateY = translateY.slice(0, -2);

  return Number(translateY);
}

/**
 * Calculate the threshold value based on given section height and window.innerHeight
 * @param thresholdRatio Not more than 1
 * @returns number[]
 */
export function getThresholds(thresholdRatio: number = 1) {
  const vhRatios = Object.keys(sections.height).map(key => {
    type Sections = "landing" | "buffer" | "history" | "faqs" | "flavor" | "contact";
    return sections.height[key as Sections] / 100;
  });

  const thresholds = [];
  let accumulator = 0;

  for (let i = 0; i < vhRatios.length; i++) {
    const sectionHeight = vhRatios[i] * window.innerHeight;

    thresholds.push(accumulator + (sectionHeight * thresholdRatio));

    accumulator += sectionHeight;
  }

  return thresholds;
}

/**
 * Gets the section numbers from thresholds list
 * @param position No negative value
 * @param thresholds Get from getThresholds()
 * @returns Index number from thresholds
 */
export function getSections(position: number, thresholds: number[]) {
  for (let i = 0; i < thresholds.length; i++) {
    if (position - thresholds[i] > 0) continue;
    else return i;
  }

  return thresholds.length - 1;
}